import React from 'react';
import { cn } from '../../../utils/cn';

interface CardProps {
  face: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
}

/**
 * Card component for the Wason Selection Task
 * Renders a card with a letter or number that can be selected
 */
export const Card: React.FC<CardProps> = ({ 
  face, 
  selected,
  onClick,
  disabled = false
}) => {
  return (
    <div 
      className={cn(
        "relative w-[90px] h-[120px] sm:w-[110px] sm:h-[140px] md:w-28 md:h-36 rounded-lg shadow-md cursor-pointer transition-all duration-300",
        "flex items-center justify-center text-3xl sm:text-4xl font-bold select-none",
        "hover:scale-105 hover:shadow-lg transform",
        selected 
          ? "ring-2 ring-orange-500 shadow-lg translate-y-[-4px]" 
          : "bg-white text-gray-800 hover:ring-1 hover:ring-orange-300",
        disabled ? "opacity-70 cursor-not-allowed hover:scale-100 hover:ring-0 translate-y-0" : "",
      )}
      onClick={disabled ? undefined : onClick}
    >
      {selected && (
        <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-pink-500 rounded-lg -z-10" />
      )}
      <div className={cn(
        "flex items-center justify-center w-full h-full rounded-lg z-10",
        selected ? "text-white" : "text-gray-800",
        "transition-colors duration-300"
      )}>
        {face}
      </div>
      
      {/* Card flip animation */}
      <div 
        className={cn(
          "absolute inset-0 bg-white rounded-lg transition-all duration-300",
          selected 
            ? "opacity-0 transform rotateY-180" 
            : "opacity-100"
        )} 
      />
    </div>
  );
}; 